module.exports = __webpack_public_path__ + "media/src/images/au-logo-19f3774aa8ef20a6f06e44398929545e.png";